import { render } from "./Section.vue?vue&type=template&id=ed95c6d4&scoped=true"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ed95c6d4"

export default script